<template>
    <div class="container">
        <h2 class="text-center mt-5">Novas Configurações</h2>
        <div class="row">
            <div class="form-group col-md-12">
                <label for="token">Token:</label>
                <input type="text" name="token" id="token" v-model="settings.token"
                       class="form-control"
                       placeholder="Deixe vazio para não editar">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-12">
                <label for="url">URL:</label>
                <input type="text" name="url" id="url" v-model="settings.url" class="form-control">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-12">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="true" id="enabled-card-reader"
                           v-model="settings.enabled_card_reader" checked>
                    <label class="form-check-label" for="enabled-card-reader">
                        Leitor de Cartao ativado ?
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-12">
                <div class="form-check ">
                    <input class="form-check-input" type="checkbox" value="true" id="enabled-print"
                           v-model="settings.enabled_print" checked>
                    <label class="form-check-label" for="enabled-print">
                        Impressora ativida ?
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <button class="btn btn-primary btn-block" type="button" @click="saveSettings">Salvar Configurações
                </button>
            </div>
        </div>
    </div>
</template>

<script>
  import getSettings from '../../support/get-settings';

  export default {
    data() {
      return {
        settings: this.settingsFactory(),
      };
    },
    mounted() {
      const settings = getSettings();
      if (settings !== null) {
        this.settings = settings;
        this.settings.token = null;
      }

    },
    methods: {
      saveSettings() {
      const settings = getSettings();

        if (!this.settings.token && (settings !== null && !settings.token)) {
            this.$swal({
                title: 'É necessário preencher o token do totem!',
                type: 'warning',
                showCancelButton: false,
                cancelButtonColor: '#d33',
                showConfirmButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Ok',
                allowOutsideClick: false,
            });
            return false;
        }

        if(!this.settings.url) {
            this.$swal({
                title: 'É necessário preencher a url do serviço!',
                type: 'warning',
                showCancelButton: false,
                cancelButtonColor: '#d33',
                showConfirmButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Ok',
                allowOutsideClick: false,
            });
            return false;
        }

        if (settings !== null && !this.settings.token) {
          this.settings.token = settings.token;
        }

        localStorage.setItem('settings', JSON.stringify(this.settings));
        this.settings = this.settingsFactory();
        this.$router.push({name: 'standby'});
      },

      settingsFactory() {
        return {
          token: null,
          url: null,
          enabled_card_reader: true,
          enabled_print: true,
        };
      },

    },
  };
</script>

<style scoped>

</style>
